import MoveTo from 'moveto';

const defaults = {
  tolerance: window.location.pathname.includes('sp/') ? 103 : 170,
  duration: 800,
  easing: 'easeInOutQuart',
};

// See Easing Equations (http://gizma.com/easing/) for more ease function.
const defaultEaseFunctions = {
  easeInOutQuart: (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t * t * t + b;
    t -= 2;
    return (-c / 2) * (t * t * t * t - 2) + b;
  },
};

const moveTo = new MoveTo(defaults, defaultEaseFunctions);

{
  const scrollTarget = document.querySelector('.event-list');
  const selectArea = document.getElementById('js-select-area');
  const selectMonth = document.getElementById('js-select-month');
  const emptyMessage = document.getElementById('js-empty');

  const targets = [...document.querySelectorAll('[data-area][data-month]')];

  let areaList = [];
  let monthList = [];
  targets.forEach((target) => {
    const _areaList = target.dataset.area.split(' ');
    areaList = [...areaList, ..._areaList];

    const _monthList = target.dataset.month.split(' ');
    monthList = [...monthList, ..._monthList];
  });

  // 重複削除
  areaList = Array.from(new Set(areaList));
  monthList = Array.from(new Set(monthList));

  {
    const options = [...selectArea.querySelectorAll('option')];
    options.forEach((option, index) => {
      if (index > 0 && !areaList.includes(option.value)) {
        selectArea.removeChild(option);
      }
    });
  }

  {
    const options = [...selectMonth.querySelectorAll('option')];
    options.forEach((option, index) => {
      if (index > 0 && !monthList.includes(option.value)) {
        selectMonth.removeChild(option);
      }
    });
  }

  const filtering = () => {
    targets.forEach((target) => {
      const isMatchArea =
        selectArea.value === '' ||
        target.dataset.area.split(' ').includes(selectArea.value);
      const isMatchMonth =
        selectMonth.value === '' ||
        target.dataset.month.split(' ').includes(selectMonth.value);

      if (isMatchArea && isMatchMonth) {
        target.style.display = '';
      } else {
        target.style.display = 'none';
      }
    });

    if (targets.every((target) => target.style.display === 'none')) {
      emptyMessage.style.display = '';
    } else {
      emptyMessage.style.display = 'none';
    }

    moveTo.move(scrollTarget);
  };

  selectArea.addEventListener('change', filtering);
  selectMonth.addEventListener('change', filtering);
}
